// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__WI-Sf","addWidgetButton":"Header_addWidgetButton__2x67l","dashboardTabs":"Header_dashboardTabs__2PWBl","active":"Header_active__2lS2Q"};